"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var lodash_keys_1 = __importDefault(require("lodash.keys"));
var operators_1 = require("rxjs/operators");
var react_dom_1 = require("react-dom");
var DefaultSharedStore = (function () {
    function DefaultSharedStore() {
        this.store = {};
        this.subjects = {};
        this.anyChangeSubject = new rxjs_1.Subject();
        this.collectionChanges = {};
    }
    DefaultSharedStore.prototype.getValue = function (key) {
        return this.store[key];
    };
    DefaultSharedStore.prototype.setValue = function (key, value) {
        if (this.setStoreValue(key, value)) {
            this.getSubject(key).next(value);
            this.anyChangeSubject.next([key]);
        }
    };
    DefaultSharedStore.prototype.update = function (update) {
        var _this = this;
        var updateKeys = lodash_keys_1.default(update);
        if (!updateKeys || updateKeys.length < 1)
            return;
        var updated = [];
        react_dom_1.unstable_batchedUpdates(function () {
            for (var _i = 0, updateKeys_1 = updateKeys; _i < updateKeys_1.length; _i++) {
                var key = updateKeys_1[_i];
                var value = update[key];
                if (_this.setStoreValue(key, value)) {
                    updated.push(key);
                }
            }
            _this.anyChangeSubject.next(updated);
            for (var _a = 0, updated_1 = updated; _a < updated_1.length; _a++) {
                var key = updated_1[_a];
                _this.getSubject(key).next(update[key]);
            }
        });
    };
    DefaultSharedStore.prototype.onChange = function (keys) {
        if (this.isSingleKey(keys)) {
            return this.getSubject(keys);
        }
        else {
            return this.onAnyOfKeysChange(keys);
        }
    };
    DefaultSharedStore.prototype.isSingleKey = function (keys) {
        return typeof keys === 'string';
    };
    DefaultSharedStore.prototype.onAnyChange = function () {
        return this.anyChangeSubject;
    };
    DefaultSharedStore.prototype.delete = function (keys) {
        var _this = this;
        react_dom_1.unstable_batchedUpdates(function () {
            keys.forEach(function (key) { return delete _this.store[key]; });
            keys.forEach(function (key) {
                var subject = _this.subjects[key];
                if (subject)
                    subject.next(undefined);
            });
            _this.anyChangeSubject.next(keys);
        });
    };
    DefaultSharedStore.prototype.allKeys = function () {
        return lodash_keys_1.default(this.store);
    };
    DefaultSharedStore.prototype.hasKey = function (key) {
        return key in this.store;
    };
    DefaultSharedStore.prototype.getSubject = function (key) {
        var subject = this.subjects[key];
        if (subject === undefined) {
            return (this.subjects[key] = new rxjs_1.Subject());
        }
        return subject;
    };
    DefaultSharedStore.prototype.setStoreValue = function (key, value) {
        var newValue = this.store[key] !== value;
        if (newValue) {
            this.store[key] = value;
            if (this.isCollection(value)) {
                this.attachCollectionChangeEvents(key, value);
            }
        }
        return newValue;
    };
    DefaultSharedStore.prototype.attachCollectionChangeEvents = function (key, collection) {
        var _this = this;
        var sub = this.collectionChanges[key];
        if (sub)
            sub.unsubscribe();
        this.collectionChanges[key] = collection.onAnyChange().subscribe(function () {
            _this.anyChangeSubject.next([key]);
        });
    };
    DefaultSharedStore.prototype.isCollection = function (value) {
        return value instanceof DefaultSharedStore;
    };
    DefaultSharedStore.prototype.onAnyOfKeysChange = function (keys) {
        if (!keys)
            return rxjs_1.empty();
        return this.anyChangeSubject.pipe(operators_1.filter(function (updated) {
            return updated.some(function (updatedKey) { return keys.some(function (key) { return key === updatedKey; }); });
        }), operators_1.map(function () { }));
    };
    return DefaultSharedStore;
}());
exports.DefaultSharedStore = DefaultSharedStore;
//# sourceMappingURL=data:application/json;base64,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